import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import priorityImg from '../../assets/about/priority.png';
import './Priority.scss';

const Priority = () => {
    return (
        <section className='priority-section emergency-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="priority-img">
                            <img src={priorityImg} alt="Önceliğimiz hastalarımız" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="priority-text">
                            <SectionTitle 
                                subTitle="ÖNCELİĞİMİZ"
                                title="Hastalarımız her zaman önceliğimizdir"
                                description="Her hastamıza ihtiyaçlarına özel, şeffaf ve güven veren bir tedavi süreci sunmayı önemsiyoruz."
                            />

                            <div className="theme-btn">
                                <Link to='/iletisim'>Randevu Al</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Priority;